import React, { useEffect, useState } from "react";
import { GSignIn } from "../firebase";
import DatePicker from "react-datepicker"; // examples : https://reactdatepicker.com/
import "react-datepicker/dist/react-datepicker.css";
import ToastNotification from "../components/ToastNotification";
import AutocompleteControlled from "../AutocompleteControlled";
import Switch from "@mui/material/Switch";
import TypeWriterEffect from "react-typewriter-effect";
import validatePhoneNumber from "../components/validatePhoneNumber";
import "./scrn1.css";
function Scrn1(props) {
  const { value, setValue, contactList, setContactList } = props;
  const [newOption, setNewOption] = useState();
  const [msgType, setMsgType] = useState("now");
  const [G_contacts, setG_contacts] = useState(false);

  const {
    setMsgbotUser,
    message,
    setMessage,
    phone,
    setPhone,
    Submit,
    loading,
    msgbotUser,
    setLoading,
    startDate,
    setStartDate,
  } = props;

  const scheduleDate = (type, date) => {
    setMsgType(type);
    setStartDate(date);
  };

  const validateInputs = async () => {
    if (newOption && !isNaN(newOption) && !validatePhoneNumber(newOption))
      return alert(`${newOption} is not valid number `);
    if (newOption && !isNaN(newOption) && validatePhoneNumber(newOption))
      return alert(`click ADD to include ${newOption}`);
    if (newOption && G_contacts && isNaN(newOption))
      return alert(`${newOption} is not added, select from options`);
    if (!message) {
      return alert("message can't be empty, Type a message to proceed");
    }
    if (msgType != "now" && startDate - Date.now() < 0) {
      return ToastNotification({
        message: `select valid time`,
      });
    }
    if (value.length == 0) return alert("No Phone Number added ");

    Submit();
  };

  return (
    <div className="container px-4 py-5 mx-auto">
      <div className="card card0">
        <div className="d-flex flex-lg-row flex-column">
          <div className="card card1">
            <div className="row justify-content-center my-auto">
              <div className="col-md-8 col-10 my-5">
                <div className="row justify-content-center px-3 mb-3">
                  <img id="logo" src="websmsbot.png" />
                </div>

                <div className="form-group">
                  <div
                    style={{
                      fontSize: "12px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                    }}
                  >
                    <label className="form-control-label text-muted">
                      Phone Number
                    </label>
                    <div className="form-group" style={{ width: "120px" }}>
                      <img
                        className="G_Contacts_img"
                        src="https://developers.google.com/identity/images/g-logo.png"
                        alt="G"
                      />
                      <span className=" text-muted">Contacts</span>
                      <Switch
                        size="small"
                        style={{ color: "grey" }}
                        onChange={() => setG_contacts(!G_contacts)}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </div>
                  </div>

                  <AutocompleteControlled
                    className="form-control"
                    G_contacts={G_contacts}
                    newOption={newOption}
                    setNewOption={setNewOption}
                    value={value}
                    setValue={setValue}
                    contactList={contactList}
                    setContactList={setContactList}
                  />
                </div>

                <div className="form-group">
                  <label className="form-control-label text-muted">
                    Message
                  </label>
                  <textarea
                    value={message}
                    type="message"
                    id="psw"
                    name="psw"
                    placeholder="Hi ..."
                    className="form-control"
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>

                {/* <div
                  className="form-group"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginRight: "0px !important",
                  }}
                >
                  <small
                    className={
                      msgType == "now" ? "activeDate btn-color " : " btn-color "
                    }
                    onClick={() => scheduleDate("now", null)}
                  >
                    Now
                  </small>
                  <DatePicker
                    className={
                      msgType != "now" ? "activeDate btn-color " : " btn-color "
                    }
                    selected={startDate}
                    onChange={(date) => scheduleDate("later", date.valueOf())}
                    showTimeInput
                    timeInputLabel="Time:"
                    dateFormat="MM/dd/yyyy h:mm aa"
                    placeholderText={new Date().toLocaleString()}
                  />
                </div> */}

                <div className="row justify-content-center ">
                  <button
                    className="btn-block btn-color submit"
                    onClick={validateInputs}
                    disabled={!msgbotUser?.email}
                  >
                    <span hidden={msgbotUser?.email} className="tooltiptext">
                      SignIn to continue
                    </span>
                    Submit
                  </button>
                </div>
                <div className="row justify-content-center ">
                  {msgbotUser ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "55px",
                      }}
                    >
                      <small display="none" className="text-muted">
                        Logged In as
                      </small>
                      <span display="none" className="text-muted">
                        {msgbotUser?.email || "You are Logged In"}
                      </span>
                    </div>
                  ) : (
                    <GSignIn
                      setMsgbotUser={setMsgbotUser}
                      setLoading={setLoading}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="card card2">
            <div className="my-auto mx-md-5 px-md-5 right">
              <div className="row justify-content-center px-3 mb-3">
                <img id="logo" src="mobsmsbot.png" />
              </div>
              <small className="text-white">
                Download MOB SMS BOT mobile app in your phone, Once Downloaded
                Login with same email Id you loggedin here. Mobile should have
                internet connection while you submit a message.
              </small>
              <a
                    className="btn-block btn-color submit"
                    // onClick={validateInputs}
                    // disabled={!msgbotUser?.email}
                    target="_blank"
                    href={"https://drive.google.com/file/d/1L4Cb261UUrriMqf8PAKc_bh-QWqHoCgG/view?usp=drive_link"}
                  >
                    Download Android app 🔗
                  </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scrn1;
